// removed by extract-text-webpack-plugin
module.exports = {"gruop-entries-loader-wrapper":"gruop-entries-loader-wrapper","gruopEntriesLoaderWrapper":"gruop-entries-loader-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/teams/addLdapGroupMappingList/groupEntriesLoader/style.scss
// module id = 1379
// module chunks = 0